import { t } from '@lingui/macro';
import { Table, TableBody, TableRow, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { KeyContextCell, KeyCreatedByCell, KeyClientIdCell, KeyDescriptionCell, KeyTitleCell, KeyTableHead, } from './components';
import { CreateApiKeyButton } from '../CreateApiKeyButton';
export function KeyTable(props) {
    const { data } = props;
    if (data.length < 1) {
        return (<EmptyState title={t({
                message: 'No keys generated',
                comment: 'Empty state title when no api keys exist',
            })} description={t({
                message: 'Integrate with other systems by generating API keys',
                comment: 'Empty state description when no api keys exist',
            })} icon={<Falcon icon="key"/>} actions={<CreateApiKeyButton appearance="secondary" icon={false}/>} withAvatar/>);
    }
    return (<Table>
      <colgroup>
        <col width="auto"/>
        <col width={1}/>
        <col width="auto"/>
        <col width="auto"/>
        <col width={1}/>
      </colgroup>
      <KeyTableHead />
      <TableBody>
        {data.map(apiKey => (<TableRow key={apiKey.id}>
            <KeyTitleCell name={apiKey.name} id={apiKey.id}/>
            <KeyDescriptionCell description={apiKey.description}/>
            <KeyClientIdCell clientId={apiKey.clientId}/>
            <KeyCreatedByCell createdBy={apiKey.userName}/>
            <KeyContextCell id={apiKey.id}/>
          </TableRow>))}
      </TableBody>
    </Table>);
}
